
import "./login_page_login_form.css";
import NavbarLogin from "../../../components/nav/nav_login";
import NavbarSignUpLogin from "../../../components/nav/nav_login_signup_login";
import AboutContainer from "../../../components/home/about/about";
import {  Link, useNavigate, useLocation,useSearchParams  } from "react-router-dom";
import { useState } from "react";
import { fetchItems, createItem } from "../../../api/networking";


const LoginPageLoginForm = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const fromSignup = location.state?.fromSignup;
    const [searchParams] = useSearchParams();
    const fromSignup2 = searchParams.get('fromSignup') === 'true';
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [firstname, setFirstname] = useState();
    const [lastname, setLastname] = useState();
    const [account_type, setaccountype] = useState();
    const [error, setError] = useState("");

    const  handleLogin = async(e) => {
        e.preventDefault();
        // TODO: Replace with real auth logic
    
        try{
          const response = await createItem('/v1/users/login',{email, password});
    
    
          if(response[0] == 200){
    
            console.log(response[1]['account_type'])
            if (response[1]['account_type']== "Admin"){
              navigate("/admin_dashboard", { state: { isAdmin: true , initials: response[1]['account_initial'] } });
            }else{
              navigate("/api_dashboard", { state: { isAdmin: false , initials: response[1]['account_initial'], email:response[1]['email'] }});
            }
            //navigate("/dashboard");
          }
    
          
        }catch(e){
          console.log("Error: ",e.status)
          console.log("Error: ",e.code)
          setError("Invalid email or password.");
        }
      };

      const passwordChange = (e)=>{
        setPassword(e.target.value)
        setError("")
      }
    

  
    return (
        <div style={{width:"70%"}}>
            <div className="login-page-form-top-container">
                <h1 className="login-page-form-top-title">Welcome Back!</h1>
                <p className="login-page-form-top-sub-title">Please enter your login details below</p>
            </div>
            <div className="login-form-container">
                <form onSubmit={handleLogin} className="login-page-form">
                            <label className="login-page-form-label" for="femail">Email</label><br/>
                            <input placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} type="email" className="login-page-form-input" required /><br/>
                            <label className="login-page-form-label" for="fpassword">Password</label><br/>
                            <input placeholder="Enter your password" onChange={passwordChange}  type="password" className="login-page-form-input"required />
                            {error == ""?<label></label>:<label className="login-page-error">{error}</label>} 
                            <br/>
                            <button  type="submit" className="login-page-form-label-button">Login</button>
                </form>
            </div>
            <div className="login-page-form-bottom">
                <div className="login-page-form-bottom-seperate-container">
                        <div className="login-page-form-bottom-seperate-items-left">
                            <p> </p>
                        </div>

                        <div className="login-page-form-bottom-seperate-items">
                            <p>or</p>
                        </div>

                        <div className="login-page-form-bottom-seperate-items-right">
                            <p> </p>
                        </div>
                </div>
            </div>
            <div>
                <div className="bottom_account_question_item">
                    Don't have an account?
                </div>
                <div className="bottom_account_question_item">
                    <Link to="/signup" className={null}><button className={"login-signup-nav-section-home-login-inner-left-login"}>Sign Up</button></Link>
                </div>
            </div>

        </div>
    );
  };
  
  export default LoginPageLoginForm;